import { render } from "./OuterListPage.vue?vue&type=template&id=66018296&scoped=true&ts=true"
import script from "./OuterListPage.vue?vue&type=script&lang=ts"
export * from "./OuterListPage.vue?vue&type=script&lang=ts"

import "./OuterListPage.vue?vue&type=style&index=0&id=66018296&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66018296"]])

export default __exports__